"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drop = void 0;
var React = require("react");
var theme_1 = require("../../theme");
var Drop = function (_a) {
    var _b = _a.color, color = _b === void 0 ? theme_1.colors.black : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
    return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", style: style },
        React.createElement("defs", null,
            React.createElement("path", { 
                // tslint:disable-next-line:max-line-length
                d: "M12.4878259,4.20869565 C12.209565,3.93043478 11.7921737,3.93043478 11.5139128,4.20869565 C11.3052172,4.4173913 5.73999977,10.1217391 5.73999977,13.7391304 C5.73999977,17.6347826 8.93999977,20 12.0008693,20 C15.0617389,20 18.2617389,17.6347826 18.2617389,13.7391304 C18.2617389,10.1217391 12.6965215,4.4173913 12.4878259,4.20869565 Z", id: "DROP-SVG-ICON-PATH" })),
        React.createElement("g", { id: "Icon/Sample", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "DROP-SVG-ICON-mask", fill: "white" },
                React.createElement("use", { xlinkHref: "#DROP-SVG-ICON-PATH" })),
            React.createElement("g", { fillRule: "nonzero" }),
            React.createElement("g", { mask: "url(#DROP-SVG-ICON-mask)", fill: color },
                React.createElement("rect", { x: "0", y: "0", width: "24", height: "24" })))));
};
exports.Drop = Drop;
//# sourceMappingURL=Drop.js.map